"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _exportNames = {
  baseLayersMap: true,
  useGeoveloMap: true
};
exports.baseLayersMap = void 0;
exports.useGeoveloMap = useGeoveloMap;
var _RateReview2 = _interopRequireDefault(require("@mui/icons-material/RateReview"));
var _FullscreenExit2 = _interopRequireDefault(require("@mui/icons-material/FullscreenExit"));
var _Fullscreen2 = _interopRequireDefault(require("@mui/icons-material/Fullscreen"));
var _MyLocation2 = _interopRequireDefault(require("@mui/icons-material/MyLocation"));
var _Add2 = _interopRequireDefault(require("@mui/icons-material/Add"));
var _Remove2 = _interopRequireDefault(require("@mui/icons-material/Remove"));
var _ChevronLeft2 = _interopRequireDefault(require("@mui/icons-material/ChevronLeft"));
var _styles = require("@mui/material/styles");
var _booleanPointInPolygon = _interopRequireDefault(require("@turf/boolean-point-in-polygon"));
var _react = _interopRequireWildcard(require("react"));
var _reactI18next = require("react-i18next");
var _components = require("../../components");
var _baseLayersControl = require("../../components/map/base-layers-control");
var _services = require("../../services");
var _translations = require("../../translations");
var _map = require("../../utils/map");
var _layers2 = require("./layers");
Object.keys(_layers2).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
  if (key in exports && exports[key] === _layers2[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _layers2[key];
    }
  });
});
var _source = require("./source");
Object.keys(_source).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
  if (key in exports && exports[key] === _source[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _source[key];
    }
  });
});
var _spain = _interopRequireDefault(require("./spain"));
var _switzerland = _interopRequireDefault(require("./switzerland"));
var _maplibreGl = require("!maplibre-gl");
var _bikeStations = require("./bike-stations");
Object.keys(_bikeStations).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
  if (key in exports && exports[key] === _bikeStations[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _bikeStations[key];
    }
  });
});
var _cyclabilityZones = require("./cyclability-zones");
Object.keys(_cyclabilityZones).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
  if (key in exports && exports[key] === _cyclabilityZones[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _cyclabilityZones[key];
    }
  });
});
var _clusters = require("./clusters");
Object.keys(_clusters).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
  if (key in exports && exports[key] === _clusters[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _clusters[key];
    }
  });
});
var _facilities = require("./facilities");
Object.keys(_facilities).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
  if (key in exports && exports[key] === _facilities[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _facilities[key];
    }
  });
});
var _mapillary = require("./mapillary");
Object.keys(_mapillary).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
  if (key in exports && exports[key] === _mapillary[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _mapillary[key];
    }
  });
});
var _osrmRouting = require("./osrm-routing");
Object.keys(_osrmRouting).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
  if (key in exports && exports[key] === _osrmRouting[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _osrmRouting[key];
    }
  });
});
var _osrmRoutingStyle = require("./osrm-routing-style");
Object.keys(_osrmRoutingStyle).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
  if (key in exports && exports[key] === _osrmRoutingStyle[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _osrmRoutingStyle[key];
    }
  });
});
var _parking = require("./parking");
Object.keys(_parking).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
  if (key in exports && exports[key] === _parking[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _parking[key];
    }
  });
});
var _partnerLayers = require("./partner-layers");
Object.keys(_partnerLayers).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
  if (key in exports && exports[key] === _partnerLayers[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _partnerLayers[key];
    }
  });
});
var _pois = require("./pois");
Object.keys(_pois).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
  if (key in exports && exports[key] === _pois[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _pois[key];
    }
  });
});
var _popup = require("./popup");
Object.keys(_popup).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
  if (key in exports && exports[key] === _popup[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _popup[key];
    }
  });
});
var _reports = require("./reports");
Object.keys(_reports).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
  if (key in exports && exports[key] === _reports[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _reports[key];
    }
  });
});
var _routeReports = require("./route-reports");
Object.keys(_routeReports).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
  if (key in exports && exports[key] === _routeReports[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _routeReports[key];
    }
  });
});
var _rides = require("./rides");
Object.keys(_rides).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
  if (key in exports && exports[key] === _rides[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _rides[key];
    }
  });
});
var _routing = require("./routing");
Object.keys(_routing).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
  if (key in exports && exports[key] === _routing[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _routing[key];
    }
  });
});
var _traces = require("./traces");
Object.keys(_traces).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
  if (key in exports && exports[key] === _traces[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _traces[key];
    }
  });
});
var _trip = require("./trip");
Object.keys(_trip).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
  if (key in exports && exports[key] === _trip[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _trip[key];
    }
  });
});
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
const baseSourceId = 'openmaptiles';
const baseLabelsSourceId = `${baseSourceId}_labels`;
const darkSourceId = 'dark';
const darkLabelsSourceId = `${darkSourceId}_labels`;
const geolocationSourceId = 'geolocation';
const exclusionZonesSourceId = 'exclusion_zone';
const dropZonesSourceId = 'exclusion_zone_drop_zones';
const countries = [{
  key: 'switzerland',
  multiPolygon: _switzerland.default
}, {
  key: 'spain',
  multiPolygon: _spain.default
}];
const baseLayersMap = exports.baseLayersMap = {
  geovelo: {
    key: 'geovelo',
    labelKey: 'commons.base_layers.geovelo'
  },
  aerial: {
    key: 'aerial',
    labelKey: 'commons.base_layers.aerial',
    url: 'https://data.geopf.fr/wmts?' + '&SERVICE=WMTS' + '&REQUEST=GetTile' + '&VERSION=1.0.0' + '&LAYER=ORTHOIMAGERY.ORTHOPHOTOS' + '&TILEMATRIXSET=PM' + '&TILEMATRIX={z}' + '&TILECOL={x}' + '&TILEROW={y}' + '&STYLE=normal' + '&FORMAT=image/jpeg',
    tileSize: 256,
    attribution: 'IGN-F/Geoportail',
    maxZoom: 18,
    alternatives: {
      switzerland: {
        key: 'aerial_switzerland',
        url: 'https://wmts10.geo.admin.ch/1.0.0/ch.swisstopo.swissimage/default/current/3857/{z}/{x}/{y}.jpeg',
        attribution: 'Source: Office fédéral de topographie'
      },
      spain: {
        key: 'aerial_spain',
        url: 'https://www.ign.es/wmts/pnoa-ma?layer=OI.OrthoimageCoverage&tilematrixset=GoogleMapsCompatible&Service=WMTS&Request=GetTile&Version=1.0.0&Format=image%2Fjpeg&TileMatrix={z}&TileCol={x}&TileRow={y}',
        tileSize: 256,
        attribution: 'Source: Instituto Geográfico Nacional'
      }
    }
  },
  ign: {
    key: 'ign',
    labelKey: 'commons.base_layers.ign',
    url: 'https://data.geopf.fr/private/wmts?' + '&SERVICE=WMTS' + '&REQUEST=GetTile' + '&VERSION=1.0.0' + '&LAYER=GEOGRAPHICALGRIDSYSTEMS.MAPS' + '&TILEMATRIXSET=PM' + '&TILEMATRIX={z}' + '&TILEROW={y}' + '&TILECOL={x}' + '&STYLE=normal' + '&FORMAT=image/jpeg' + '&apikey=ign_scan_ws',
    tileSize: 256,
    attribution: 'IGN-F/Geoportail',
    maxZoom: 18,
    alternatives: {
      switzerland: {
        key: 'ign_switzerland',
        url: 'https://wmts10.geo.admin.ch/1.0.0/ch.swisstopo.pixelkarte-farbe/default/current/3857/{z}/{x}/{y}.jpeg',
        attribution: 'Source: Office fédéral de topographie'
      },
      spain: {
        key: 'ign_spain',
        url: 'https://www.ign.es/wmts/mapa-raster?layer=MTN&tilematrixset=GoogleMapsCompatible&Service=WMTS&Request=GetTile&Version=1.0.0&Format=image%2Fjpeg&TileMatrix={z}&TileCol={x}&TileRow={y}',
        tileSize: 256,
        attribution: 'Source: Instituto Geográfico Nacional'
      }
    }
  },
  dark: {
    key: 'dark',
    labelKey: 'commons.base_layers.dark'
  }
};
function useGeoveloMap() {
  let {
    baseLayers,
    baseLayersPlacement,
    baseLayer: _baseLayer,
    smallDevice,
    layersDrawerOpen,
    currentUser,
    currentLanguage,
    hillshadesShowed,
    theme: _theme,
    onClick,
    onLayersControlToggle,
    onLanguageButtonClick,
    onGetCurrentPositionFailure,
    onContribute
  } = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  const [map, setMap] = (0, _react.useState)();
  const mapRef = (0, _react.useRef)();
  const [options, setOptions] = (0, _react.useState)();
  const layerOpacities = (0, _react.useRef)({});
  const [bounds, setBounds] = (0, _react.useState)();
  const [center, setCenter] = (0, _react.useState)();
  const [zoom, setZoom] = (0, _react.useState)();
  const [initialized, setInitialized] = (0, _react.useState)(false);
  const initializedRef = (0, _react.useRef)(false);
  const [controlsInitialized, setControlsInitialized] = (0, _react.useState)(false);
  const country = (0, _react.useRef)('france');
  const [baseLayer, _setBaseLayer] = (0, _react.useState)(_baseLayer || 'geovelo');
  const baseLayerRef = (0, _react.useRef)(_baseLayer || 'geovelo');
  const backgroundsLayersRef = (0, _react.useRef)({});
  const hillshadesLayersRef = (0, _react.useRef)({});
  const baseLayersControlRef = (0, _react.useRef)();
  const contributeControlRef = (0, _react.useRef)();
  const layersControlRef = (0, _react.useRef)();
  const attributionControlRef = (0, _react.useRef)(new _maplibreGl.AttributionControl());
  const languagesControlRef = (0, _react.useRef)();
  const {
    t
  } = (0, _reactI18next.useTranslation)();
  const defaultTheme = (0, _styles.useTheme)();
  const theme = _theme ? _theme : defaultTheme;
  const {
    addGeoJSONSource: addGeolocationSource,
    updateGeoJSONSource: updateGeolocationSource
  } = (0, _source.useSource)(map, geolocationSourceId);
  const {
    addCircleLayer,
    getLayerOpacities
  } = (0, _layers2.useLayers)(map);
  (0, _react.useEffect)(() => {
    if (map && !initialized) {
      const [[west, south], [east, north]] = map.getBounds().toArray();
      initLabelsSources();
      initGeolocationSource();
      initControls(map);
      setBounds({
        north,
        east,
        south,
        west
      });
      setCenter(map.getCenter());
      setInitialized(true);
    }
  }, [map]);
  (0, _react.useEffect)(() => {
    if (initialized && center) {
      const {
        lat,
        lng
      } = center;
      const point = {
        type: 'Point',
        coordinates: [lng, lat]
      };
      const countryKey = countries.find(_ref => {
        let {
          multiPolygon
        } = _ref;
        return (0, _booleanPointInPolygon.default)(point, multiPolygon);
      })?.key || 'france';
      country.current = countryKey;
      if (baseLayerRef.current !== 'geovelo' && baseLayerRef.current !== 'dark') setBaseLayer(baseLayerRef.current);
    }
  }, [initialized, center]);
  (0, _react.useEffect)(() => {
    if (layersControlRef.current) layersControlRef.current.update({
      title: t('commons.actions.configure_layers') || ''
    });
    if (currentLanguage && languagesControlRef.current) {
      const {
        icon,
        label
      } = _translations.languages[currentLanguage];
      languagesControlRef.current.update({
        icon,
        title: label
      });
    }
  }, [currentLanguage]);
  (0, _react.useEffect)(() => {
    if (controlsInitialized && contributeControlRef.current) {
      contributeControlRef.current.update({}, () => onContribute?.());
    }
  }, [currentUser]);
  (0, _react.useEffect)(() => {
    if (map && controlsInitialized && smallDevice) {
      if (map.hasControl(attributionControlRef.current)) map.removeControl(attributionControlRef.current);
      map.addControl(attributionControlRef.current, 'bottom-left');
      if (layersControlRef.current) {
        if (map.hasControl(layersControlRef.current)) map.removeControl(layersControlRef.current);
        map.addControl(layersControlRef.current, 'bottom-left');
        layersControlRef.current.update();
      }
      if (baseLayersControlRef.current) {
        if (map.hasControl(baseLayersControlRef.current)) map.removeControl(baseLayersControlRef.current);
        map.addControl(baseLayersControlRef.current, 'bottom-left');
        baseLayersControlRef.current.update();
      }
    }
  }, [controlsInitialized, smallDevice]);
  (0, _react.useEffect)(() => {
    if (layersControlRef.current) {
      if (layersDrawerOpen) {
        layersControlRef.current.update({
          color: 'default',
          icon: /*#__PURE__*/_react.default.createElement(_ChevronLeft2.default, null),
          size: 'medium',
          title: t('commons.actions.close') || '',
          variant: 'round'
        }, () => {
          if (onLayersControlToggle) onLayersControlToggle(false);
        });
      } else {
        layersControlRef.current.update({
          color: 'primary',
          icon: /*#__PURE__*/_react.default.createElement(_components.FilterIcon, null),
          size: smallDevice ? 'medium' : 'large',
          title: t('commons.actions.configure_layers') || '',
          variant: smallDevice ? 'round' : 'extended'
        }, () => {
          if (onLayersControlToggle) onLayersControlToggle(true);
        });
      }
    }
  }, [layersDrawerOpen, smallDevice]);
  (0, _react.useEffect)(() => {
    if (baseLayerRef.current === 'geovelo') {
      if (hillshadesShowed) {
        hillshadesLayersRef.current?.base?.forEach(layer => map && !map.getLayer(layer.id) && map.addLayer(layer));
      }
    } else if (baseLayerRef.current === 'dark') {
      if (hillshadesShowed) {
        hillshadesLayersRef.current?.dark?.forEach(layer => map && !map.getLayer(layer.id) && map.addLayer(layer));
      }
    }
    return () => {
      if (mapRef.current) {
        hillshadesLayersRef.current?.base?.forEach(_ref2 => {
          let {
            id
          } = _ref2;
          return map?.getLayer(id) && map.removeLayer(id);
        });
        hillshadesLayersRef.current?.dark?.forEach(_ref3 => {
          let {
            id
          } = _ref3;
          return map?.getLayer(id) && map.removeLayer(id);
        });
      }
    };
  }, [baseLayer, hillshadesShowed]);
  async function getStyle(dark) {
    const {
      tileServer: {
        url: tileServerUrl,
        styleDirs: {
          base: styleDir,
          dark: darkStyleDir
        }
      }
    } = _services.AppService.environment;
    const {
      layers: _layers,
      ...style
    } = await (0, _map.getDataFromUrl)(`${tileServerUrl}/styles/${dark ? darkStyleDir : styleDir}/style.json`);
    const layers = _layers.filter(layer => hillshadesShowed || layer.type === 'background' || 'source' in layer && [baseSourceId, exclusionZonesSourceId, dropZonesSourceId].includes(layer.source));
    const backgroundLayer = _layers.find(layer => layer.type === 'background');
    const hillshadesLayers = _layers.filter(layer => 'source' in layer && layer.source === 'hillshades');
    return {
      ...style,
      layers,
      backgroundLayer,
      hillshadesLayers,
      version: 8 // hack for typing issue
    };
  }
  async function init(_ref4) {
    let {
      baseLayer: _baseLayer,
      ...options
    } = _ref4;
    if (initializedRef.current) return;
    initializedRef.current = true;
    setOptions(options);
    if (_baseLayer) {
      baseLayerRef.current = _baseLayer;
      _setBaseLayer(_baseLayer);
    }
    if (options.center === undefined) delete options.center;
    if (options.zoom === undefined) delete options.zoom;
    const {
      scaleControl,
      customZoomControls,
      zoomControlsPosition,
      locateControl,
      fullscreenControl,
      baseLayersControl,
      layersControl,
      contributeControl,
      languagesControl,
      ...mapOptions
    } = options;
    const dark = baseLayerRef.current === 'dark';
    let style;
    let sources = {};
    const layers = [];
    if (!baseLayers || baseLayers.includes('geovelo')) {
      _services.MapService.style = await getStyle(false);
      const {
        sources: _sources,
        layers: _layers,
        backgroundLayer,
        hillshadesLayers,
        ..._style
      } = _services.MapService.style;
      backgroundsLayersRef.current['base'] = backgroundLayer;
      hillshadesLayersRef.current['base'] = hillshadesLayers;
      style = _style;
      sources = _sources;
      const baseLayers = _layers.filter(_ref5 => {
        let {
          type
        } = _ref5;
        return type !== 'background';
      });
      layers.push(...baseLayers);
      layerOpacities.current = {
        ...layerOpacities.current,
        ...getLayerOpacities(layers, baseSourceId)
      };
    }
    if (baseLayers?.includes('dark')) {
      _services.MapService.darkStyle = await getStyle(true);
      const {
        sources: _sources,
        layers: _layers,
        backgroundLayer,
        hillshadesLayers,
        ..._style
      } = _services.MapService.darkStyle;
      backgroundsLayersRef.current['dark'] = backgroundLayer;
      hillshadesLayersRef.current['dark'] = hillshadesLayers;
      if (!style) style = _style;
      sources[darkSourceId] = _sources[baseSourceId];
      const darkLayers = _layers.filter(_ref6 => {
        let {
          type
        } = _ref6;
        return type !== 'background';
      }).map(_ref7 => {
        let {
          id,
          ...props
        } = _ref7;
        return {
          ...props,
          id: `${id}_dark`,
          source: darkSourceId
        };
      });
      layers.push(...darkLayers);
      layerOpacities.current = {
        ...layerOpacities.current,
        ...getLayerOpacities(darkLayers, darkSourceId)
      };
      if (dark) toggleLayers(layers, baseSourceId, false, true);else toggleLayers(layers, darkSourceId, false, true);
    }
    const backgroundLayer = backgroundsLayersRef.current[dark ? 'dark' : 'base'];
    if (backgroundLayer) layers.splice(0, 0, backgroundLayer);
    if (!style) return;
    const newMap = new _maplibreGl.Map({
      style: {
        ...style,
        sources,
        layers
      },
      minZoom: 1,
      maxZoom: 17.99,
      renderWorldCopies: false,
      ...mapOptions,
      attributionControl: false
    });
    newMap.once('styledata', () => {
      const customLayerProps = {
        type: 'custom',
        renderingMode: '2d',
        prerender: () => undefined,
        render: () => undefined,
        onAdd: () => undefined,
        onRemove: () => undefined
      };
      newMap.addLayer({
        id: 'basemap',
        ...customLayerProps
      });
      newMap.addLayer({
        id: 'facilities',
        ...customLayerProps
      });
      newMap.addLayer({
        id: 'partnerLayers',
        ...customLayerProps
      });
      newMap.addLayer({
        id: 'labels',
        ...customLayerProps
      });
      newMap.addLayer({
        id: '_labels',
        ...customLayerProps
      });
    });
    newMap.once('load', async () => {
      mapRef.current = newMap;
      setMap(newMap);
      (baseLayers || _components.defaultBaseLayers).forEach(key => {
        const {
          url,
          tileSize,
          attribution,
          alternatives
        } = baseLayersMap[key];
        if (key === 'aerial' || key === 'ign') {
          newMap.addSource(key, {
            type: 'raster',
            tiles: url ? [url] : undefined,
            tileSize: tileSize || 256,
            attribution
          });
          if (alternatives) {
            Object.values(alternatives).forEach(_ref8 => {
              let {
                key: alternativeKey,
                url: alternativeUrl,
                tileSize: alternativeTileSize,
                attribution: alternativeAttribution
              } = _ref8;
              newMap.addSource(alternativeKey, {
                type: 'raster',
                tiles: alternativeUrl ? [alternativeUrl] : undefined,
                tileSize: alternativeTileSize || 256,
                attribution: alternativeAttribution
              });
            });
          }
        }
      });
    });
    newMap.addControl(attributionControlRef.current, smallDevice ? 'bottom-left' : 'bottom-right');
    if (onClick) {
      newMap.on('click', _ref9 => {
        let {
          lngLat: {
            lat,
            lng
          }
        } = _ref9;
        onClick({
          type: 'Point',
          coordinates: [lng, lat]
        });
      });
    }
    newMap.on('moveend', () => {
      const [[west, south], [east, north]] = newMap.getBounds().toArray();
      setBounds({
        north,
        east,
        south,
        west
      });
      const {
        lat,
        lng
      } = newMap.getCenter();
      setCenter({
        lat,
        lng
      });
      setZoom(newMap.getZoom());
    });
  }
  function destroy() {
    map?.remove();
    mapRef.current = undefined;
    setMap(undefined);
    setInitialized(false);
    initializedRef.current = false;
  }
  function toggleLayers() {
    let layers = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
    let sourceId = arguments.length > 1 ? arguments[1] : undefined;
    let showed = arguments.length > 2 ? arguments[2] : undefined;
    let init = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : false;
    layers.forEach(layer => {
      if ('source' in layer && layer.source === sourceId) {
        const layerOpacity = layerOpacities.current[layer.id];
        const opacity = showed ? layerOpacity !== undefined ? layerOpacity : 1 : 0;
        if (layer.type === 'fill') {
          if (init && layer.paint) layer.paint['fill-opacity'] = opacity;else map?.setPaintProperty(layer.id, 'fill-opacity', opacity);
        } else if (layer.type === 'line') {
          if (init && layer.paint) layer.paint['line-opacity'] = opacity;else map?.setPaintProperty(layer.id, 'line-opacity', opacity);
        } else if (layer.type === 'symbol') {
          if (init && layer.paint) {
            layer.paint['icon-opacity'] = opacity;
            layer.paint['text-opacity'] = opacity;
          } else {
            map?.setPaintProperty(layer.id, 'icon-opacity', opacity);
            map?.setPaintProperty(layer.id, 'text-opacity', opacity);
          }
        } else {
          const visibility = showed ? 'visible' : 'none';
          if (init && layer.layout) layer.layout.visibility = visibility;
          map?.setLayoutProperty(layer.id, 'visibility', visibility);
        }
      }
    });
  }
  async function setBaseLayer(key) {
    const layers = map?.getStyle().layers;
    let rasterLayerId;
    if (key === 'aerial' || key === 'ign') {
      toggleLayers(layers, baseSourceId, false);
      toggleLayers(layers, darkSourceId, false);
      toggleLayers(layers, darkLabelsSourceId, false);
      if (key === 'ign') {
        toggleLayers(layers, baseLabelsSourceId, false);
      } else {
        toggleLayers(layers, baseLabelsSourceId, true);
      }
      map?.setPaintProperty('background', 'background-color', backgroundsLayersRef.current.base?.paint?.['background-color']);
      const _zoom = map?.getZoom();
      const _baseLayer = baseLayersMap[key];
      const {
        key: id,
        maxZoom
      } = _zoom && _zoom >= 9 && _baseLayer.alternatives?.[country.current] || _baseLayer;
      if (map && !map.getLayer(id)) {
        map.addLayer({
          id,
          type: 'raster',
          source: id,
          maxzoom: maxZoom || 22
        }, 'basemap');
      }
      rasterLayerId = id;
    } else if (key === 'dark') {
      toggleLayers(layers, baseSourceId, false);
      toggleLayers(layers, baseLabelsSourceId, false);
      map?.setPaintProperty('background', 'background-color', backgroundsLayersRef.current.dark?.paint?.['background-color']);
      toggleLayers(layers, darkSourceId, true);
      toggleLayers(layers, darkLabelsSourceId, true);
    } else {
      if (baseLayerRef.current === 'dark') {
        toggleLayers(layers, darkSourceId, false);
        toggleLayers(layers, darkLabelsSourceId, false);
        map?.setPaintProperty('background', 'background-color', backgroundsLayersRef.current.base?.paint?.['background-color']);
      }
      toggleLayers(layers, baseSourceId, true);
      toggleLayers(layers, baseLabelsSourceId, true);
    }
    if (baseLayerRef.current === 'aerial' || baseLayerRef.current === 'ign') {
      const alternatives = baseLayersMap[baseLayerRef.current].alternatives;
      if (baseLayerRef.current !== rasterLayerId && map?.getLayer(baseLayerRef.current)) map.removeLayer(baseLayerRef.current);
      if (alternatives) {
        Object.values(alternatives).forEach(_ref10 => {
          let {
            key: alternativeKey
          } = _ref10;
          if (alternativeKey !== rasterLayerId && map?.getLayer(alternativeKey)) map.removeLayer(alternativeKey);
        });
      }
    }
    baseLayerRef.current = key;
    _setBaseLayer(key);
    baseLayersControlRef.current?.update({
      baseLayer: key
    });
  }
  async function initLabelSource(dark) {
    const {
      tileServer: {
        url: tileServerUrl,
        styleDirs: {
          labels: styleDir,
          darkLabels: darkStyleDir
        }
      }
    } = _services.AppService.environment;
    const labelsSourceId = dark ? darkLabelsSourceId : baseLabelsSourceId;
    let labelsStyle;
    if (dark) {
      labelsStyle = _services.MapService.darkLabelsStyle = _services.MapService.darkLabelsStyle || (await (0, _map.getDataFromUrl)(`${tileServerUrl}/styles/${darkStyleDir}/style.json`));
    } else {
      labelsStyle = _services.MapService.labelsStyle = _services.MapService.labelsStyle || (await (0, _map.getDataFromUrl)(`${tileServerUrl}/styles/${styleDir}/style.json`));
    }
    const {
      sources,
      layers
    } = labelsStyle;
    if (!map?.getSource(labelsSourceId)) map?.addSource(labelsSourceId, sources[baseSourceId]);
    layers.forEach(layer => {
      if (!('source' in layer)) return;
      layer.source = labelsSourceId;
      if (dark) layer.id = `${layer.id}_dark`;
    });
    layerOpacities.current = {
      ...layerOpacities.current,
      ...getLayerOpacities(layers, labelsSourceId)
    };
    if (baseLayers?.includes('dark') && baseLayerRef.current === 'dark' && !dark) toggleLayers(layers, labelsSourceId, false, true);else if (baseLayers?.includes('dark') && baseLayerRef.current !== 'dark' && dark) toggleLayers(layers, labelsSourceId, false, true);
    layers.forEach(layer => {
      if (map && !map.getLayer(layer.id)) map.addLayer(layer, '_labels');
    });
  }
  async function initLabelsSources() {
    if (!baseLayers || baseLayers.includes('geovelo')) initLabelSource(false);
    if (baseLayers?.includes('dark')) initLabelSource(true);
  }
  function initGeolocationSource() {
    addGeolocationSource();
    addCircleLayer('geolocation', geolocationSourceId, {
      'circle-radius': ['get', 'radius'],
      'circle-color': ['get', 'color'],
      'circle-opacity': ['get', 'opacity']
    });
  }
  function initControls(initializedMap) {
    if (!options) return;
    const {
      scaleControl: showScaleControl,
      container,
      customZoomControls: customZoomControlsEnabled,
      zoomControlsPosition,
      locateControl: locateControlEnabled,
      fullscreenControl: fullscreenControlEnabled,
      baseLayersControl: baseLayersControlEnabled,
      layersControl: layersControlEnabled,
      contributeControl: contributeControlEnabled,
      languagesControl: languagesControlEnabled
    } = options;
    function addPrefix(suffix) {
      const prefix = typeof container === 'string' ? container : container.id;
      return `${prefix}-${suffix}`;
    }

    // Scale control
    if (showScaleControl) {
      const scaleControl = new _maplibreGl.ScaleControl({
        maxWidth: 100,
        unit: 'imperial'
      });
      initializedMap.addControl(scaleControl, 'bottom-right');
      scaleControl.setUnit('metric');
    }

    // Zoom controls
    if (customZoomControlsEnabled) {
      const zoomOutControl = new _components.ButtonControl(addPrefix('zoom-out-control'), {
        icon: /*#__PURE__*/_react.default.createElement(_Remove2.default, null),
        title: t('commons.actions.zoom_out')
      }, map => map.zoomOut());
      initializedMap.addControl(zoomOutControl, zoomControlsPosition || 'bottom-right');
      zoomOutControl.init(theme);
      const zoomInControl = new _components.ButtonControl(addPrefix('zoom-in-control'), {
        icon: /*#__PURE__*/_react.default.createElement(_Add2.default, null),
        title: t('commons.actions.zoom_in')
      }, map => map.zoomIn());
      initializedMap.addControl(zoomInControl, zoomControlsPosition || 'bottom-right');
      zoomInControl.init(theme);
    } else if (zoomControlsPosition) {
      const navControl = new _maplibreGl.NavigationControl({});
      initializedMap.addControl(navControl, zoomControlsPosition);
    }

    // Locate control
    if (locateControlEnabled && 'geolocation' in navigator) {
      const locateControl = new _components.ButtonControl(addPrefix('locate-control'), {
        icon: /*#__PURE__*/_react.default.createElement(_MyLocation2.default, null),
        title: t('commons.actions.locate_me')
      }, map => {
        navigator.geolocation.getCurrentPosition(_ref11 => {
          let {
            coords: {
              latitude: lat,
              longitude: lng
            }
          } = _ref11;
          const point = {
            type: 'Point',
            coordinates: [lng, lat]
          };
          map.flyTo({
            center: {
              lat,
              lng
            },
            zoom: 15
          });
          updateGeolocationSource({
            type: 'FeatureCollection',
            features: [{
              type: 'Feature',
              geometry: point,
              properties: {
                radius: 10,
                color: '#2196f3',
                opacity: 0.5
              }
            }, {
              type: 'Feature',
              geometry: point,
              properties: {
                radius: 6,
                color: 'white',
                opacity: 1
              }
            }, {
              type: 'Feature',
              geometry: point,
              properties: {
                radius: 4,
                color: '#2196f3',
                opacity: 1
              }
            }]
          });
        }, () => onGetCurrentPositionFailure?.() || console.error('cannot get current position'));
      });
      initializedMap.addControl(locateControl, 'bottom-right');
      locateControl.init(theme);
    }

    // Fullscreen control
    if (fullscreenControlEnabled && document.body?.requestFullscreen) {
      const fullscreenControl = new _components.ButtonControl(addPrefix('fullscreen-control'), {
        icon: /*#__PURE__*/_react.default.createElement(_Fullscreen2.default, null),
        title: t('commons.actions.enter_fullscreen')
      }, () => {
        if (!document.fullscreenElement) {
          document.body.requestFullscreen();
        } else if (document.exitFullscreen) {
          document.exitFullscreen();
        }
      });
      initializedMap.addControl(fullscreenControl, 'bottom-right');
      fullscreenControl.init(theme);
      document.addEventListener('fullscreenchange', () => {
        if (document.fullscreenElement) {
          fullscreenControl.update({
            icon: /*#__PURE__*/_react.default.createElement(_FullscreenExit2.default, null),
            title: t('commons.actions.exit_fullscreen') || ''
          });
        } else {
          fullscreenControl.update({
            icon: /*#__PURE__*/_react.default.createElement(_Fullscreen2.default, null),
            title: t('commons.actions.enter_fullscreen') || ''
          });
        }
      });
    }

    // Contribute control
    if (contributeControlEnabled) {
      contributeControlRef.current = new _components.ButtonControl(addPrefix('contribute-control'), {
        color: 'secondary',
        icon: /*#__PURE__*/_react.default.createElement(_RateReview2.default, null),
        title: t('commons.actions.contribute')
      }, () => onContribute?.());
      initializedMap.addControl(contributeControlRef.current, 'bottom-right');
      contributeControlRef.current.init(theme);
    }

    // Layers control
    if (layersControlEnabled) {
      layersControlRef.current = new _components.ButtonControl(addPrefix('layers-control'), {
        color: 'primary',
        icon: /*#__PURE__*/_react.default.createElement(_components.FilterIcon, null),
        size: smallDevice ? 'medium' : 'large',
        title: t('commons.actions.configure_layers'),
        tooltipPlacement: 'right',
        variant: smallDevice ? 'round' : 'extended'
      }, () => {
        if (onLayersControlToggle) onLayersControlToggle(true);
      });
      initializedMap.addControl(layersControlRef.current, 'bottom-left');
      layersControlRef.current.init(theme);
    } else if (baseLayersControlEnabled) {
      baseLayersControlRef.current = new _baseLayersControl.BaseLayersControl({
        baseLayers,
        baseLayer: baseLayerRef.current,
        baseLayersPlacement
      }, baseLayer => setBaseLayer(baseLayer));
      initializedMap.addControl(baseLayersControlRef.current, baseLayersPlacement || 'bottom-left');
      baseLayersControlRef.current.init(theme);
    }

    // Languages control
    if (languagesControlEnabled && currentLanguage) {
      const {
        icon,
        label
      } = _translations.languages[currentLanguage];
      languagesControlRef.current = new _components.ButtonControl(addPrefix('languages-control'), {
        ariaControls: 'languages-menu',
        ariaHasPopup: true,
        icon,
        title: label
      }, (_, event) => {
        if (onLanguageButtonClick) onLanguageButtonClick(event);
      });
      initializedMap.addControl(languagesControlRef.current, 'bottom-right');
      languagesControlRef.current.init(theme);
    }
    setControlsInitialized(true);
  }
  return {
    map,
    initialized,
    bounds,
    zoom,
    baseLayer,
    init,
    destroy,
    setBaseLayer
  };
}